<ngx-material-timepicker-face [selectedTime]="selectedHour" [faceTime]="hoursList" [format]="format"
                              (timeChange)="hourChange.next($event)"
                              (timeSelected)="onTimeSelected($event)"></ngx-material-timepicker-face>
